'use client';

import { 
  ControlType, 
  CalculatorId, 
  CalculatorType,
  ControlIds,
  type CalculatorConfig,
  DataTableInputMode,
  type ControlValues,
  type SingleColumnSelectControl
} from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';
import { QuartileCalculator } from './quartile-calculator';
import { calculateQuartiles } from '../../../lib/stats/quartile';

export interface QuartileControlValues extends ControlValues {
  [ControlIds.Values]: string;
}

export const quartileControls = {
  tabs: [
    {
      title: 'Data',
      controls: [
        {
          id: ControlIds.Values,
          type: ControlType.SingleColumnSelect,
          label: 'Select Data Column',
          required: true,
          numericOnly: true,
          defaultValue: 'scores'
        } as SingleColumnSelectControl
      ]
    }
  ]
};

export const quartileCalculatorConfig: CalculatorConfig<CalculatorId.QUARTILE> = {
  id: CalculatorId.QUARTILE,
  type: CalculatorType.Graph,
  name: 'Quartile Calculator',
  dataTableInputMode: DataTableInputMode.Required,
  initialData: TableDataJSON.from({
    columns: [
      { 
        id: 'scores',
        name: 'Test Scores', 
        values: ['65', '70', '75', '80', '85', '90', '95', '85', '80', '75', '95', '100', '60', '75', '85'] 
      },
      {
        id: 'salaries',
        name: 'Annual Salaries ($K)',
        values: ['45', '48', '52', '55', '58', '60', '65', '70', '75', '80', '85', '90', '95', '100', '110']
      },
      {
        id: 'heights',
        name: 'Heights (cm)',
        values: ['165', '170', '175', '168', '172', '180', '167', '173', '178', '169', '171', '176', '174', '177', '170']
      }
    ]
  }),
  initialControlValues: {
    [ControlIds.Values]: 'scores'
  },
  controls: quartileControls,
  getInitialConfig: (data: TableDataJSON) => ({
    [ControlIds.Values]: data.columns[0]?.id || ''
  }),
  getVisualizationData: (params: { data: TableDataJSON; controls: ControlValues }) => {
    const columnId = params.controls[ControlIds.Values] as string;
    const values = params.data.columns
      .find(col => col.id === columnId)
      ?.values
      .map(v => Number(v))
      .filter(v => !isNaN(v));
    
    if (!values || values.length === 0) return null;
    return calculateQuartiles(values);
  },
  render: ({ visualizationData }) => <QuartileCalculator visualizationData={visualizationData} />
}; 